import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import useQuestionnaireStore from '../store/useQuestionnaireStore';
import useWarning from '../hooks/useWarningModal';
import { ChevronLeft, Zap, Flame, Activity, Cloud, Sparkles } from 'lucide-react';
import Button from '../components/common/Button';

const painTypes = [
    { id: 'dull', label: 'Dull Aching', icon: <Cloud size={32} />, description: "A steady, lingering ache." },
    { id: 'sharp', label: 'Sharp Shooting', icon: <Zap size={32} />, description: "Sudden, intense bursts of pain." },
    { id: 'burning', label: 'Burning', icon: <Flame size={32} />, description: "Feels like heat or fire." },
    { id: 'throbbing', label: 'Throbbing', icon: <Activity size={32} />, description: "Pulsing or beating sensation." },
    { id: 'tingling', label: 'Tingling', icon: <Sparkles size={32} />, description: "Pins and needles sensation." },
];

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.1 }
    }
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
};

const Step7_PainType = () => {
    const navigate = useNavigate();
    const { painType, setPainType } = useQuestionnaireStore();
    const showWarning = useWarning();

    const handleSelect = (id) => {
        setPainType(id);
    };

    const handleNext = () => {
        if (painType) {
            console.log("Pain Type:", painType);
            navigate('/step-8');
        } else {
            showWarning("Please describe how your pain feels.");
        }
    };

    return (
        <motion.div
            className="page step7-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="step-header">
                <button onClick={() => navigate(-1)} className="back-button">
                    <ChevronLeft size={24} /> Back
                </button>
                <h2>How does your pain feel?</h2>
            </div>

            <motion.div 
                className="pain-type-grid"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {painTypes.map((type) => (
                    <motion.button
                        key={type.id}
                        className={`pain-card ${painType === type.id ? 'selected' : ''}`}
                        onClick={() => handleSelect(type.id)}
                        variants={itemVariants}
                        whileHover={{ scale: 1.03, boxShadow: "0 8px 20px rgba(0,0,0,0.1)" }}
                        whileTap={{ scale: 0.98 }}
                    >
                        <div className="icon-container">{type.icon}</div>
                        <div className="text-container">
                            <h3>{type.label}</h3>
                            <p>{type.description}</p>
                        </div>
                    </motion.button>
                ))}
            </motion.div>

            <div className="navigation-buttons">
                <Button onClick={handleNext}>Next</Button>
            </div>
        </motion.div>
    );
};

export default Step7_PainType;